module.exports = __webpack_public_path__ + "img/mongo.0e9486bc.jpg";